<div class="prompt-content-container">
    <div class="question-number">{{ 'prompts.newFields.completed.title' | translate }}</div>
    <div class="question-title">{{ 'prompts.newFields.completed.subtitle' | translate }}</div>
</div>

<div class="buttons-container">
    <button class="btn-solid-neutral single-button" (click)="next.emit()">{{ 'main.close' | translate }}</button>
</div>
